import { useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
// import { signup } from "../../redux/authSlice";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import { setUser } from "../../redux/authSlice";
import { FaUpload, FaUserCircle } from "react-icons/fa";
import ProcessingBar from "utils/Processingbar";
import userApi from "api/user/user.api";
import { useNavigate } from "react-router-dom";
import { hashPassword } from "utils/hashPassword";
import Uploader from "utils/Uploader";

const SignupForm = ({ switchAuthState, actionState }) => {
  const dispatch = useDispatch();
  const [isLoginRequest, setIsLoginRequest] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const [Images, setImages] = useState([]);

  const navigate = useNavigate();

  const signupForm = useFormik({
    initialValues: {
      username: "",
      displayName: "",
      password: "",
      confirmPassword: "",
      photo: "",
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .min(3, "Email must be at least 3 characters")
        .required("Required"),
      displayName: Yup.string()
        .min(3, "Name must be at least 3 characters")
        .required("Required"),
      password: Yup.string()
        .min(3, "Password must be at least 3 characters")
        .required("Required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Required"),
    }),
    onSubmit: async (values) => {
      setErrorMessage("");
      setIsLoginRequest(true);
      // let responseSignUp = dispatch(signup(values));

      const hashedPassword = await hashPassword(values.password);

      const hashedConfirmPassword = await hashPassword(values.confirmPassword);

      console.log("value sign up --->", values);
      // console.log("Formik Errors Before Submit:", signupForm.errors);

      const payload = {
        username: values.username,
        displayName: values.displayName,
        password: hashedPassword, // send the hashed one
        confirmPassword: hashedConfirmPassword,
        photo: Images[0] || "",
      };

      const { response, err } = await userApi.signup(payload);

      console.log({ payload });

      // console.log({ err });

      if (response) {
        signupForm.resetForm();
        setIsLoginRequest(false);
        // dispatch(setUser(response.data));
        navigate(`/verify-email?email=${encodeURIComponent(values.username)}`);
        dispatch(setAuthModalOpen(false));
        toast.success(response?.data?.message);
      }

      if (err) {
        const errorMsg = err?.response?.data?.message || "Something went wrong";
        setErrorMessage(errorMsg);
        toast.error(errorMsg); // Show the error in a Toast
        setIsLoginRequest(false);
      }
    },
  });

  const updateImages = (url) => {
    setImages([url]);
  };

  return (
    <form onSubmit={signupForm.handleSubmit} className="space-y-4">
      <input
        type="text"
        name="username"
        placeholder="E-mail"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-reddark placeholder:text-textGray"
        onChange={signupForm.handleChange}
        onBlur={signupForm.handleBlur} // Required for Formik validation to trigger on blur
        value={signupForm.values.username}
      />

      {signupForm.touched.username && signupForm.errors.username && (
        <div className="text-red-500 text-sm mt-1">
          {signupForm.errors.username}
        </div>
      )}

      <input
        type="text"
        name="displayName"
        placeholder="Name"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-reddark placeholder:text-textGray"
        onChange={signupForm.handleChange}
        value={signupForm.values.displayName}
      />

      {signupForm.touched.displayName && signupForm.errors.displayName && (
        <div className="text-red-500 text-sm mt-1">
          {signupForm.errors.displayName}
        </div>
      )}

      <input
        type="password"
        name="password"
        placeholder="Password"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-reddark placeholder:text-textGray"
        onChange={signupForm.handleChange}
        value={signupForm.values.password}
      />

      {signupForm.touched.password && signupForm.errors.password && (
        <div className="text-red-500 text-sm mt-1">
          {signupForm.errors.password}
        </div>
      )}

      <input
        type="password"
        name="confirmPassword"
        placeholder="Confirm Password"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-reddark placeholder:text-textGray"
        onChange={signupForm.handleChange}
        value={signupForm.values.confirmPassword}
      />

      {signupForm.touched.confirmPassword &&
        signupForm.errors.confirmPassword && (
          <div className="text-red-500 text-sm mt-1">
            {signupForm.errors.confirmPassword}
          </div>
        )}

      {/* Avatar Upload Section */}
      <Uploader refreshFunction={updateImages} previewImage={Images[0]} />

      {/* Progress Bar */}
      {isUploading && (
        <div className="w-full bg-gray-200 h-2 rounded-md mt-2 overflow-hidden">
          <div
            className="h-full bg-green-500 transition-all"
            style={{ width: `${uploadProgress}%` }}
          />
        </div>
      )}

      <button
        type="submit"
        className="w-full bg-red-400 text-white py-2 rounded-md hover:bg-red-600"
        style={{ background: "linear-gradient(-45deg, #f87171, #991b1b)" }}
        disabled={isLoginRequest}
      >
        {isLoginRequest ? <ProcessingBar /> : "Sign Up"}
      </button>

      <div className="flex items-center my-8">
        <div className="flex-grow h-px bg-gray-500"></div>
        <span className="px-4 text-sm text-neutral-300">OR</span>
        <div className="flex-grow h-px bg-gray-500"></div>
      </div>

      <button
        type="button"
        onClick={() => switchAuthState(actionState.signin)}
        className="w-full text-center text-textGray hover:text-white mt-4 border border-reddark py-2 rounded-md "
      >
        Sign In
      </button>

      {errorMessage && (
        <p className="text-red-500 text-sm text-center">{errorMessage}</p>
      )}
    </form>
  );
};

export default SignupForm;
